import thunk from "redux-thunk";

import { authReducer } from "../reducer/authReducer";
import { printReducer } from "../reducer/printReducer";
import { gisReducer } from "../reducer/gisReducer";

const { createStore, combineReducers, applyMiddleware, compose } = require("redux");

//allow middleWare
const composeEnhancers = (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

//diferents reducers
const reducers= combineReducers({
    auth: authReducer,
    print: printReducer,
    gis: gisReducer,
})


export const store = createStore(
                                    reducers,
                                    composeEnhancers(
                                        applyMiddleware(thunk)
                                    )
                                );